import { useMutation } from '@tanstack/react-query'
import { Feedback, sendFeedback } from 'api/review'
import { useAuthContext } from 'components/auth'

export function useSendFeedbackMutation(options: {
  onSuccess?: () => void
  onError?: (err: Error) => void
}) {
  const { company } = useAuthContext()

  return useMutation({
    mutationFn: async (feedbackItems: Feedback[]) => {
      if (!company?.id) {
        throw new Error('Company id not found')
      }

      return sendFeedback(company.id, feedbackItems)
    },
    ...options,
  })
}
